import cx from 'classnames';

import { MDText } from 'i18n-react';

import { SLUGS } from '@motorway/mw-enquiry-states/static';

import {
  formatLiveSaleTimeLeft,
  formatSaleStartsIn,
  getLiveSaleMinutesLeft,
  getMinutesUntilSaleStarts,
} from './LiveSaleHeader.helpers';
import { useMinutesCountdown } from './LiveSaleHeader.hooks';
import Texts from './LiveSaleHeader.texts.json';

import styles from './LiveSaleHeader.module.scss';

const LocalT = new MDText(Texts);

type LiveSaleHeaderProps = {
  className?: string;
  enquiryStateSlug?: string | null;
};

type ClassNameProps = Pick<LiveSaleHeaderProps, 'className'>;

const LiveSaleCountdown = ({ className }: ClassNameProps) => {
  const minutesLeft = useMinutesCountdown(getLiveSaleMinutesLeft);

  return (
    <div className={cx(styles.component, styles.live, className)} data-testid="liveSaleHeader">
      <div className={styles.status}>
        <span aria-hidden="true" className={styles.pulse} />
        <span>{LocalT.translate('live.title')}</span>
      </div>
      <span>{minutesLeft === null ? '' : formatLiveSaleTimeLeft(minutesLeft)}</span>
    </div>
  );
};

const ReadyForSaleCountdown = ({ className }: ClassNameProps) => {
  const minutesLeft = useMinutesCountdown(getMinutesUntilSaleStarts);

  return (
    <div className={cx(styles.component, styles.readyForSale, className)} data-testid="readyForSaleHeader">
      <span>{minutesLeft === null ? '' : formatSaleStartsIn(minutesLeft)}</span>
    </div>
  );
};

export const LiveSaleHeader = ({ className, enquiryStateSlug }: LiveSaleHeaderProps) => {
  if (enquiryStateSlug === SLUGS.SALE_ACTIVE) {
    return <LiveSaleCountdown className={className} />;
  }

  if (enquiryStateSlug === SLUGS.READY_FOR_SALE) {
    return <ReadyForSaleCountdown className={className} />;
  }

  return null;
};
